import React from 'react'
import { ScrollableSelect } from '../../../components/ui/ScrollableSelect'
import { useDevice } from '../../../lib/hooks/useDevice'
import { MOBILE_BREAKPOINT } from '../draw/draw-commons'
import { selectOptions } from '../data'

interface Props {
  selected: { country: string; country_code: string }
  onChange: (option: { country: string; country_code: string }) => void
}

export const Header: React.FunctionComponent<Props> = ({ selected, onChange }) => {
  const [isMobile] = useDevice(MOBILE_BREAKPOINT)

  const wrapperResponsiveCss = isMobile
    ? 'flex-column items-start'
    : 'flex-row justify justify-center items-end'

  const titleResponsiveCss = isMobile ? 'mb3' : 'absolute left-0 bottom-0'

  return (
    <div className="add-prod-padding">
      <div className={`flex relative mb3 ${wrapperResponsiveCss}`}>
        <div className={`f3 ${titleResponsiveCss}`}>Emissions</div>
        <ScrollableSelect
          className={`z-2`}
          valueClassName="ma1 bn br-pill pv2 ph3 outline-0 pointer bg-blue500 white hover-bg-blue600 f6"
          value={selected}
          options={selectOptions}
          getOptionLabel={(option) => option.country}
          onChange={onChange}
        />
      </div>
    </div>
  )
}
